import React from 'react';
import { StackFrame } from '../../../core/types/console.types';
import { cn } from '../../utils/cn';

interface Props {
  frames: StackFrame[];
  onNavigate?: (fileName: string, lineNumber: number, columnNumber: number) => void;
}

export const ConsoleStackTrace: React.FC<Props> = ({ frames, onNavigate }) => {
  const handleFrameClick = (frame: StackFrame) => {
    if (onNavigate) {
      onNavigate(frame.fileName, frame.lineNumber, frame.columnNumber);
    }
  };

  return (
    <div className="mt-1 ml-4 text-xs font-mono">
      {frames.map((frame, index) => (
        <div
          key={index}
          className={cn(
            'py-0.5 text-zinc-500',
            onNavigate && 'hover:text-blue-400 cursor-pointer hover:underline'
          )}
          onClick={() => handleFrameClick(frame)}
        >
          <span className="text-zinc-600">at </span>
          <span className="text-zinc-400">{frame.functionName}</span>
          <span className="text-zinc-600"> (</span>
          <span className="text-blue-400">{frame.fileName}</span>
          <span className="text-zinc-600">:</span>
          <span className="text-yellow-400">{frame.lineNumber}</span>
          <span className="text-zinc-600">:</span>
          <span className="text-yellow-400">{frame.columnNumber}</span>
          <span className="text-zinc-600">)</span>
        </div>
      ))}
    </div>
  );
};
